// Same Google Maps key used by jcgnWeb2026 (VITE_GOOGLE_MAPS_API_KEY)
const WEB_GOOGLE_MAPS_API_KEY = "AIzaSyBMe4bWdA11mSKCUE1sUPTSzbXTLtoQ9Ss";

export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || WEB_GOOGLE_MAPS_API_KEY;
